import React from 'react';
import { Grid, Skeleton } from '@mui/material';

export const RegistrationPersonalDetailsFormSkeleton = () => {
    return (
        <>
            <Grid container spacing={2}>
                {Array(8)
                    .fill(undefined)
                    .map((_, k: number) => (
                        <Grid size={{ xs: 12, sm: 6 }} key={k}>
                            <Skeleton height={45} />
                        </Grid>
                    ))}
                <Grid size={12}>
                    <Skeleton height={45} />
                </Grid>
                {Array(3)
                    .fill(undefined)
                    .map((_, k: number) => (
                        <Grid size={12} key={k}>
                            <Skeleton height={60} />
                        </Grid>
                    ))}
            </Grid>
            <Grid
                container
                spacing={2}
                sx={{
                    marginTop: 1,
                }}
            >
                <Grid size={10}>
                    <Skeleton height={60} />
                </Grid>
                <Grid size={2}>
                    <Skeleton height={60} width={'100%'} />
                </Grid>
            </Grid>
        </>
    );
};
